import React, { useContext, useEffect, useState } from "react";
import { Tabs } from "antd";
import { SecurityContext } from "context/SecurityContextProvider";
import { OpcionService } from "services";
import { OPCIONES } from "enums";
import { SolicitudesPendientesAprobacionPage } from "./pendiente-aprobacion";
import { ConsultaSolicitudesPage } from "./consulta-solicitudes";
import { TabCalendario } from "./components";
import { BloqueoMovimientosPage } from "./bloqueo-movimientos";

const SolicitudesAusenciaPage = () => {
    const { getUsuarioAutenticado } = useContext(SecurityContext);
    const [codigosOpciones, setCodigosOpciones] = useState([]);

    useEffect(() => {
        const cargarOpciones = async () => {
            try {
                const codigos = await OpcionService.listar(getUsuarioAutenticado().id);
                setCodigosOpciones(codigos || []);
            } catch (error) {
                setCodigosOpciones([]);
            }
        };
        cargarOpciones();
    }, []);

    const puedeConfigurarBloqueo = codigosOpciones.includes(
        OPCIONES.PAGINA_VACACIONES_SEGUIMIENTO_SOLICITUDES.HABILITAR_RESTRICCIONES_SOLICITUDES
    );

    return (
        <ContainerTabs>
            <Tabs destroyInactiveTabPane={true}>
                <Tabs.TabPane key="solicitudes-pendientes-aprobacion" tab="Solicitudes pendientes de aprobación">
                    <SolicitudesPendientesAprobacionPage />
                </Tabs.TabPane>
                <Tabs.TabPane key="consultar-solicitudes" tab="Consultar solicitudes">
                    <ConsultaSolicitudesPage />
                </Tabs.TabPane>
                <Tabs.TabPane key="calendario" tab="Calendario">
                    <TabCalendario />
                </Tabs.TabPane>
                {puedeConfigurarBloqueo && (
                    <Tabs.TabPane key="bloqueo-movimientos" tab="Bloqueo de movimientos">
                        <BloqueoMovimientosPage />
                    </Tabs.TabPane>
                )}
            </Tabs>
        </ContainerTabs>
    );
};

const ContainerTabs = ({ children }) => {
    return (
        <div style={{ padding: "10px 20px", background: "white" }}>
            {children}
        </div>
    );
};

export default SolicitudesAusenciaPage;
